export const addSA = (feature) => {
  // console.log('addSA')
  return {
    type: 'SMALL_AREA_ADDED',
    payload: feature
  }
}

export const addLEA = (feature) => {
  // console.log('addLEA')
  return {
    type: 'LOCAL_ELECTORAL_ADDED',
    payload: feature
  }
}

export const addCrime = (feature) => {
  // console.log('addCrime')
  return {
    type: 'GARDA_SUBDIVISION_ADDED',
    payload: feature
  }
}

export const addAirbnb = (feature) => {
  // console.log('addAirbnb')
  return {
    type: 'AIRBNBS_ADDED',
    payload: feature
  }
}

export const addProperySales = (feature) => {
  // console.log('addPropertySales')
  return {
    type: 'PROPERTIES_ADDED',
    payload: feature
  }
}

export const addNoise = (feature) => {
  // console.log('addNoise')
  return {
    type: 'NOISE_ADDED',
    payload: feature
  }
}


// WEBPACK FOOTER //
// ./src/actions/index.js